import { useEffect } from "react";
import { REACT_APP_GTM_TOGGLE, REACT_APP_GTM_ID } from "../../config";

/**
 * Component to inject Google Tag Manager noscript iframe
 * This should be placed as high in the body as possible
 * Only renders if GTM is enabled via environment variable
 */
const GoogleTagManagerNoscript = () => {
  const gtmId = REACT_APP_GTM_ID;
  const gtmEnabled = REACT_APP_GTM_TOGGLE && !!gtmId;

  useEffect(() => {
    // If GTM is enabled and we have an ID, inject the noscript iframe
    if (gtmEnabled && gtmId) {
      // Create noscript element
      const noscript = document.createElement("noscript");

      // Create iframe element
      const iframe = document.createElement("iframe");
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      iframe.height = "0";
      iframe.width = "0";
      iframe.style.display = "none";
      iframe.style.visibility = "hidden";

      // Append iframe to noscript
      noscript.appendChild(iframe);

      // Insert at the beginning of body
      document.body.insertBefore(noscript, document.body.firstChild);

      // Cleanup on unmount
      return () => {
        if (noscript.parentNode) {
          noscript.parentNode.removeChild(noscript);
        }
      };
    }
  }, [gtmEnabled, gtmId]);

  // Component doesn't render anything visible
  return null;
};

export default GoogleTagManagerNoscript;
